import type { AasApiAdapter } from "../adapter";
import { requestJson } from "../http";

export const authApi: AasApiAdapter["auth"] = {
	async requestPasswordReset(email) {
		await requestJson<{ status: boolean; message: string }>("/api/auth/request-password-reset", {
			method: "POST",
			body: {
				email,
				redirectTo: `${window.location.origin}/reset-password`,
			},
		});
		return {
			message: `If an account for ${email} exists, a reset link has been sent.`,
		};
	},
	async resetPassword(token, newPassword) {
		await requestJson<{ status: boolean }>("/api/auth/reset-password", {
			method: "POST",
			body: { token, newPassword },
		});
		return {
			message: "Password reset successful. You can now login with your new password.",
		};
	},
	async verifyEmail(token) {
		await requestJson<{ status: boolean }>("/api/auth/verify-email", {
			method: "GET",
			query: { token },
		});
		return {
			message: "Email verified. Redirecting to login...",
		};
	},
};
